import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from './toast.service';
import { StoreFacadeService } from '../store/store-facade.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private handlingExpiredSession = false;

  constructor(
    private router: Router,
    private toastService: ToastService,
    private storeFacadeSv: StoreFacadeService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('access_token');
    const isLoginRequest = req.url.includes('/auth/login');

    if (token && !isLoginRequest && this.isTokenExpired(token)) {
      this.handleExpiredSession();
      return throwError(() => new HttpErrorResponse({
        status: 401,
        statusText: 'Token expirado',
        url: req.url
      }));
    }

    if (token) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error?.status === 401 && !isLoginRequest) {
            this.handleExpiredSession();
          }
          return throwError(() => error);
        })
      );
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === 401 && !isLoginRequest) {
          this.handleExpiredSession();
        }
        return throwError(() => error);
      })
    );
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payloadPart = token.split('.')[1];
      if (!payloadPart) {
        return false;
      }

      const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
      const decoded = JSON.parse(atob(base64));
      const exp = Number(decoded?.exp || 0);
      if (!exp) {
        return false;
      }

      const nowInSeconds = Math.floor(Date.now() / 1000);
      return nowInSeconds >= exp;
    } catch {
      return false;
    }
  }

  private handleExpiredSession(): void {
    if (this.handlingExpiredSession) {
      return;
    }

    this.handlingExpiredSession = true;
    localStorage.removeItem('access_token');
    localStorage.removeItem('access_token_chatbot');
    localStorage.removeItem('current_user');
    localStorage.removeItem('appointment_data');
    localStorage.removeItem('appointment_data_temp');
    this.storeFacadeSv.dispatchLogout();
    this.toastService.warning('Tu sesión expiró. Inicia sesión nuevamente.', 4500);
    this.router.navigate(['/login']).finally(() => {
      setTimeout(() => {
        this.handlingExpiredSession = false;
      }, 300);
    });
  }
}